export default function SingleEqual({ count = 1 }) {
  return (
    <div className="icon-container">
      {new Array(count).fill("").map((_, i) => (
        <svg
          key={i}
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M11 12.6641H21M11 19.3307H21"
            stroke="#FF6B00"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <rect
            x="0.75"
            y="0.75"
            width="30.5"
            height="30.5"
            rx="7.25"
            stroke="#0059B1"
            stroke-width="1.5"
          />
        </svg>
      ))}
    </div>
  );
}
